import { Routes } from '@angular/router';
import {
  MAIN_PATH,
  AUTH_ROUTES,
  EXERCISE_LIBRARY_ROUTES,
  PROGRAMS_ROUTES,
  PERX_ROUTES,
  BONUS_WORKOUT_ROUTES,
  EMAIL_ROUTES,
  SMS_ROUTES,
  MEMBERS_ROUTES,
  USER_ROUTES,
  SETTINGS_ROUTES,
  DASHBOARD_ROUTES,
  AI_CHAT_ROUTES,
  FALLBACK_ROUTES,
} from './shared/constants/routes.constants';
import { guestChildGuard } from './core/auth/guards/guest-child.guard';
import { authChildGuard } from './core/auth/guards/auth-child.guard';
import { roleChildGuard, roleGuard } from './core/auth/guards/role/role.guard';
import { ROLE_GUARD_KEYS } from './core/auth/guards/role/role.constants';
import { USER_TYPES } from './core/firestore/collections/users/users-collection.constants';
import { headerResolver } from './layout/main-layout/components/navbar/header.resolver';
import { DashboardService } from './features/dashboard/dashboard.service';

export const routes: Routes = [
  {
    path: AUTH_ROUTES.ROOT,
    canActivateChild: [guestChildGuard],
    loadComponent: () =>
      import('./layout/auth-layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_PAGE_ROUTES),
  },
  {
    path: MAIN_PATH,
    canActivateChild: [authChildGuard],
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
    resolve: {
      navbar: headerResolver,
    },
    children: [
      {
        path: DASHBOARD_ROUTES.ROOT,
        canActivate: [roleGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.ADMIN, USER_TYPES.DOCTOR],
        },
        providers: [DashboardService],
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        title: 'Analytics Dashboard | GolfDr™',
      },
      {
        path: EXERCISE_LIBRARY_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.ADMIN, USER_TYPES.DOCTOR, USER_TYPES.SUPPORT],
        },
        loadChildren: () =>
          import('./features/exercise-library/exercise-library.routes').then(
            (m) => m.EXERCISE_LIBRARY_PAGE_ROUTES,
          ),
      },
      {
        path: PROGRAMS_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.ADMIN, USER_TYPES.DOCTOR, USER_TYPES.SUPPORT],
        },
        loadChildren: () =>
          import('./features/programs/programs.routes').then((m) => m.PROGRAMS_PAGE_ROUTES),
      },
      {
        path: PERX_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.ADMIN, USER_TYPES.DOCTOR, USER_TYPES.SUPPORT],
        },
        loadChildren: () =>
          import('./features/personalized-exercise/personalized-exercise.routes').then(
            (m) => m.PERSONALIZED_EXERCISE_PAGE_ROUTES,
          ),
      },
      {
        path: BONUS_WORKOUT_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.ADMIN, USER_TYPES.DOCTOR, USER_TYPES.SUPPORT],
        },
        loadChildren: () =>
          import('./features/bonus-workout/bonus-workout.routes').then(
            (m) => m.BONUS_WORKOUT_PAGE_ROUTES,
          ),
      },
      {
        path: EMAIL_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.DOCTOR],
        },
        loadChildren: () =>
          import('./features/email/email.routes').then((m) => m.EMAIL_PAGE_ROUTES),
      },
      {
        path: SMS_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.DOCTOR],
        },
        loadChildren: () => import('./features/sms/sms.routes').then((m) => m.SMS_PAGE_ROUTES),
      },
      {
        path: MEMBERS_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.DOCTOR],
        },
        loadChildren: () =>
          import('./features/member/member.routes').then((m) => m.MEMBER_PAGE_ROUTES),
      },
      {
        path: USER_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.ADMIN, USER_TYPES.DOCTOR],
        },
        loadChildren: () =>
          import('./features/users/users.routes').then((m) => m.USERS_PAGE_ROUTES),
      },
      {
        path: AI_CHAT_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.ADMIN, USER_TYPES.DOCTOR, USER_TYPES.SUPPORT],
        },
        loadChildren: () =>
          import('./features/ai-chat/ai-chat.routes').then((m) => m.AI_CHAT_PAGE_ROUTES),
      },
      {
        path: SETTINGS_ROUTES.ROOT,
        canActivateChild: [roleChildGuard],
        data: {
          [ROLE_GUARD_KEYS.ROLES]: [USER_TYPES.ADMIN, USER_TYPES.DOCTOR],
        },
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.SETTINGS_PAGE_ROUTES),
      },
    ],
  },
  {
    path: FALLBACK_ROUTES.ROOT,
    redirectTo: `${AUTH_ROUTES.ROOT}/${AUTH_ROUTES.RELATIVE.SIGN_IN}`,
  },
];
